import { Clock } from 'lucide-react';

const WORDS_PER_MINUTE = 200;

interface ReadingTimeProps {
  /** Raw text content to calculate reading time from */
  text?: string;
  /** Pre-computed minutes (use for static pages where text isn't a single string) */
  minutes?: number;
  className?: string;
}

export function ReadingTime({ text, minutes: minutesProp, className = '' }: ReadingTimeProps) {
  const minutes = minutesProp ?? Math.max(1, Math.round(
    (text?.trim().split(/\s+/).filter(Boolean).length ?? 0) / WORDS_PER_MINUTE,
  ));

  return (
    <span className={`inline-flex items-center gap-1 text-xs text-text-tertiary ${className}`}>
      <Clock className="h-3.5 w-3.5" />
      {minutes} min read
    </span>
  );
}
